import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

// Import slice reducers
import getClinicInfoReducer from "./slices/clinic/get-clinicinfo-slice";
import getRecruiterListReducer from "./slices/recruiter/get-recruiter-slice";
import getTimezoneListReducer from "./slices/timezone/get-timezone-slice";
import getDiseaseByClinicIdReducer from "./slices/disease/get-disease-slice";
import getTrailsReducer from "./slices/trial/get-trial-slice";
import getTrailsNameReducer from "./slices/trial/get-trial-name-slice";
import getPatientReducer from "./slices/patients/get-patients-slice";
import getWorkflowTrialByIdReducer from "./slices/workflow/get-workflow-by-id";
import metaIntegrationReducer from "./slices/meta-integration/meta-integration-slice";
import userReducer from "./slices/user/userSlice";
import getCountryInfoReducer from "./slices/country-state/get-country-info-slice";
import callReducer from "./slices/twilio-calls/call-slice";
import viewReducer from "./slices/twilio-calls/view-slice";
import notificationsReducer from "./slices/notifications/unread-count";
// Combine all slice reducers
const rootReducer = combineReducers({
  clinic_info: getClinicInfoReducer,
  country: getCountryInfoReducer,
  recruiter_list: getRecruiterListReducer,
  time_zone: getTimezoneListReducer,
  disease_by_clinic_id: getDiseaseByClinicIdReducer,
  workflow_by_trial_id: getWorkflowTrialByIdReducer,
  trails: getTrailsReducer,
  trails_name: getTrailsNameReducer,
  patients: getPatientReducer,
  user: userReducer,
  meta: metaIntegrationReducer,
  call: callReducer,
  callView: viewReducer,
  notify_unread_count:notificationsReducer
});

// Create the Redux store without persist
const store = configureStore({
  reducer: (state, action) => {
    if (action.type === "LOGOUT") {
      return rootReducer(undefined, action); // Reset state on logout
    }
    return rootReducer(state, action);
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Allow non-serializable actions if needed
    }),
});

export default store;
